import * as React from 'react';
import CollapsingList from './collapsing_list';
import SelectFacetOption from './select_facet_option';
import { Filter, WidgetType } from './search_filters';

interface IProps {
  filter: Filter;
  trackingQuery?: string;
}

const COLLAPSE_THRESHOLD = 7;

export default function SelectFacet({ filter, trackingQuery }: IProps) {
  return (
    <div className="facet">
      <div className="facet__heading">{filter.name}</div>
      <CollapsingList
        countThreshold={filter.aggregationName === 'TRAITS' ? 3 : COLLAPSE_THRESHOLD}
      >
        {filter.options.map((option, idx) => (
          <SelectFacetOption
            key={idx}
            option={option}
            checkbox={filter.widgetType === WidgetType.CHECKBOX}
            trackingQuery={trackingQuery}
          />
        ))}
      </CollapsingList>
    </div>
  );
}
